import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AcceptInvite() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const token = search.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const accept = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/team/accept-invite", { token, password });
      localStorage.setItem("nusa_token", r.data.access_token);
      toast.success(`Selamat datang di ${r.data?.workspace?.name || "workspace Anda"}!`);
      window.location.href = "/app/dashboard";
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal menerima undangan"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFDFC]" data-testid="accept-invite-page">
      <div className="w-full max-w-md p-8 bg-white border border-slate-200 rounded-md">
        <h1 className="font-serif-display text-3xl font-medium text-slate-900">Terima Undangan</h1>
        <p className="text-sm text-slate-500 mt-1">Setel password Anda untuk melanjutkan.</p>
        <form onSubmit={accept} className="mt-6 space-y-4">
          <div><Label>Password Baru</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required data-testid="accept-password-input" /></div>
          <Button type="submit" className="w-full h-11 bg-slate-900" disabled={loading || !token} data-testid="accept-submit-btn">
            {loading ? "Memproses..." : "Terima & Masuk"}
          </Button>
        </form>
      </div>
    </div>
  );
}
